import React from 'react';

export const RadioIcon = ({
  width = '19',
  height = '14',
  color = '#667085',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M12.6149 3.10833C13.0798 3.5727 13.4486 4.12414 13.7002 4.73113C13.9518 5.33812 14.0813 5.98876 14.0813 6.64583C14.0813 7.30291 13.9518 7.95354 13.7002 8.56054C13.4486 9.16753 13.0798 9.71897 12.6149 10.1833M5.54822 10.175C5.08334 9.71063 4.71454 9.15919 4.46292 8.5522C4.2113 7.94521 4.08179 7.29458 4.08179 6.6375C4.08179 5.98042 4.2113 5.32979 4.46292 4.7228C4.71454 4.11581 5.08334 3.56437 5.54822 3.1M14.9732 0.75C16.5355 2.31273 17.4131 4.43197 17.4131 6.64167C17.4131 8.85137 16.5355 10.9706 14.9732 12.5333M3.18989 12.5333C1.62763 10.9706 0.75 8.85137 0.75 6.64167C0.75 4.43197 1.62763 2.31273 3.18989 0.75M10.7482 6.64167C10.7482 7.56214 10.002 8.30833 9.08155 8.30833C8.16108 8.30833 7.41489 7.56214 7.41489 6.64167C7.41489 5.72119 8.16108 4.975 9.08155 4.975C10.002 4.975 10.7482 5.72119 10.7482 6.64167Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
